import { getAuthenticated, postAuthenticated } from './http';

const ADMIN_API_BASE = '/api/admin';

export const fetchAdminSummary = () => getAuthenticated(`${ADMIN_API_BASE}/summary`);

export const generateAdminTestData = () =>
  postAuthenticated(`${ADMIN_API_BASE}/test-data/generate`, {});

export const resetAdminTestData = () =>
  postAuthenticated(`${ADMIN_API_BASE}/test-data/reset`, {});

export const simulateAdminNotification = () =>
  postAuthenticated(`${ADMIN_API_BASE}/notifications/simulate`, {});
